// Scroll to an element by id and briefly flash a highlight ring — used to land
// a user on the exact post/question a notification points to.
export function scrollAndFlash(id, { delay = 350 } = {}) {
  setTimeout(() => {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const prevShadow = el.style.boxShadow;
    const prevTrans  = el.style.transition;
    el.style.transition = 'box-shadow 0.35s ease';
    el.style.boxShadow  = '0 0 0 3px var(--org), 0 10px 34px rgba(255,106,0,0.35)';
    setTimeout(() => {
      el.style.boxShadow = prevShadow;
      setTimeout(() => { el.style.transition = prevTrans; }, 400);
    }, 1800);
  }, delay);
}
